import React from 'react';
import { Modal } from 'react-bootstrap';
import OrderCard from '../OrderCard/OrderCard';

function OrderModal({ order, orderMeta, orderRowsMeta, show, onHide }) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Tilauksen tiedot
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <OrderCard
                        order={order}
                        orderMeta={orderMeta}
                        orderRowsMeta={orderRowsMeta}
                    />
                    <br/>
                </Modal.Body>
            </div>
        </Modal>
    );
};

export default OrderModal;